import React from 'react'
import { Box, Typography, Alert } from '@mui/material'

/**
 * Ops Section Component - STUB
 * TODO: Implement operational permission toggles
 */
export default function OpsSection({ data, onChange, disabled, loading, error }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Operational Toggles
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        TODO: Implement 7 operational permission toggles
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Alert severity="info">
        This section needs implementation. See SPRINT.md for details.
      </Alert>
    </Box>
  )
}
